import { render } from "./EauDeParfum.vue?vue&type=template&id=6a5f1207&scoped=true"
const script = {}

import "./EauDeParfum.vue?vue&type=style&index=0&id=6a5f1207&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5f1207"]])

export default __exports__